var Views  = {};

Views.Base = Backbone.View.extend({});

Views.CategoryShowSettings = Views.Base.extend({
  el: '.js-contraception-visible',
  events: {
    'click' : 'saveSettings',
  },
  initialize: function() {
  },
  saveSettings: function(event) {
    var _this, $btn, post_data, is_contraception_visible;
    _this = this;
    $btn = $(event.currentTarget);
    if (!App.isEnabled($btn)) {
      return;
    }

    if ($btn.text() === 'OFF') {
      if (! window.confirm('本当に避妊カテゴリの質問を表示してもよろしいですか？')) {
        return;
      }
      is_contraception_visible = 1; // true or falseだとstringになってしまい、Cakeのvalidationに引っ掛かる
    } else {
      is_contraception_visible = 0;
    }

    post_data = {
      "data[token]"                          : App.me.token, // tokenセット
      "data[User][is_contraception_visible]" : is_contraception_visible,
    };

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/user/edit.json',
      data: post_data
    }).done(function(json) {
      // OFFにした時だけAlertを表示
      if (is_contraception_visible === 0) {
        alert('カテゴリ表示設定を更新しました。');
        $btn.text('OFF');
        $btn.removeClass('other-settings__list__switch__btn--on');
        $btn.addClass('other-settings__list__switch__btn--off');
      } else {
        $btn.text('ON');
        $btn.removeClass('other-settings__list__switch__btn--off');
        $btn.addClass('other-settings__list__switch__btn--on');
      }
      mixpanel.track("ContraceptionVisibleChange",  {"IsContraceptionVisible": is_contraception_visible});
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.setEnabled($btn, true);
    });
  },
});



Views.UserSettings = Views.Base.extend({
  el: '#user-settings',
  events: {
    'click .save-btn' : 'saveSettings',
  },
  initialize: function() {
  },
  saveSettings: function() {
    var _this, $btn, name, post_data;
    _this = this;
    //$btn = $(event.currentTarget); これだと#user-settings(this?)が$btnになってしまう
    $btn = this.$('.save-btn');
    if (!App.isEnabled($btn)) {
      return;
    }

    name = this.$('input[name="user-name"]').val();
    if (! name) {
      alert('表示名を入力してください');
      return;
    }

    post_data = {
      "data[token]"             : App.me.token, // tokenセット
      "data[User][name]"        : name,
      "data[User][description]" : this.$('textarea[name="user-description"]').val(),
    };

    App.changeText($btn, "通信中...");
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/user/edit.json',
      data: post_data
    }).done(function(json) {
      //alert('表示名を更新しました。');
      location.href = '/mypage';
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
});

Views.SleepTimeSettings = Views.Base.extend({
  el: ".js-sleep-time-settings",
  events: {
    "click .js-sleep-time-save-btn": "saveSettings",
  },
  initialize: function() {
  },
  saveSettings: function(event) {
    var _this, $btn, sleep_time;
    _this = this;
    $btn  = $(event.currentTarget, this.$el);
    if (! App.isEnabled(_this.$el)) {
      return;
    }

    if ($btn.data('sleepTime') === null) { // 解除するボタン
      sleep_time = null;
    } else { // 設定するボタン
      sleep_time = $('.js-sleep-time-select').val();
      if (sleep_time === 'null') {
        alert('時間帯を指定して下さい');
        return;
      }
    }

    const post_data = {
      "data[token]"            : App.me.token, // tokenセット
      "data[User][sleep_time]" : sleep_time,
    };
    $.ajax({
      type    : 'POST',
      headers : {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      beforeSend : function() {
        App.setEnabled(_this.$el, false);
        App.changeText($btn, "通信中...");
      },
      url  : '/api/user/sleep_time.json',
      data : post_data
    }).done(function(json) {
      var current_setting_label, queries, setting_alert_message;
      setting_alert_message = sleep_time ? "おやすみモードを設定しました" : "おやすみモードを解除しました";
      // mixpanelには整数値として扱えるように加工して送信
      mixpanel.track("SleepTimeSetting",  {"SleepTime": (sleep_time ? parseInt(sleep_time.replace(/:/g, '')) : null)});
      if (sleep_time) {
        current_setting_label = 'ON (' + $('.js-sleep-time-select :selected', this.$el).text() + ')';

        // 退会画面から来た場合トップへ戻る
        queries = App.getUrlQueries();
        if (_.has(queries, 'move_to') && queries['move_to'] === 'top') {
          location.href = 'mamariq://back_to_top';
        }
      } else {
        current_setting_label = 'OFF';
      }
      $('.js-sleep-time-current-setting', this.$el).text(current_setting_label);
      alert(setting_alert_message);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (data && _.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.restoreText($btn);
      App.setEnabled(_this.$el, true);
    });

  },
});

Views.Unregister = Views.Base.extend({
  el: '.js-unregister-form',
  events: {
    'click .js-unregister': 'unregister',
    'click .js-cancel': 'cancelUnregister',
    'change input[name="reason"]': 'showTextarea'
  },
  unregister: function(event) {
    var $btn = $(event.currentTarget);
    if (!App.isEnabled($btn)) {
      return;
    }

    var $reason = this.$('input[name="reason"]:checked');
    var $detail = this.$('textarea[name="reason-detail"]');
    var $other = $('textarea[name="other"]');

    if (typeof $reason.val() === 'undefined') {
      alert('退会理由を選択してください');
      return;
    }

    if ($detail.val().trim() === '') {
      alert('退会理由の詳細を入力してください');
      return;
    }

    var data = {
      'data[token]': App.me.token,
      'data[Unregister][reason]': $reason.val(),
      'data[Unregister][reason_detail]': $detail.val(),
      'data[Unregister][other]': $other.val()
    };

    if ($reason.data('showSleepTimerPopup')) {
      // おやすみモード設定ポップアップを表示
      return this.showSleepTimerPopup(data, $btn);
    }

    this.requestUnregister(data, $btn);
  },
  requestUnregister: function(data, $btn) {
    // 退会は重要な処理なので1度confirmを出す
    if (!window.confirm('退会するとデータの復旧はできません。本当に退会してもよろしいですか？')) {
      // popupに紐付けたイベントを解除する(複数発火を防ぐため)
      $('.js-suggest-sleep-mode-popup__sleep-mode').off('click');
      $('.js-suggest-sleep-mode-popup__unregister').off('click');
      return;
    }

    App.changeText($btn, '通信中...');
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: { 'X-MAMARIQ-UUID' : App.me.User.uuid },
      url: '/api/user/unregister.json',
      data: data
    }).done(function() {
      // Mixpanelで退会をトラック
      mixpanel.track('Unregistered', {
        Reason: data['data[Unregister][reason]'],
        ReasonDetail: data['data[Unregister][reason_detail]']
      });
      // 退会の完了をネイティブでハンドリングする
      location.href = 'mamariq://unregistered';
    }).fail(function(jqXHR) {
      // ボタンの状態を元に戻す
      App.restoreText($btn);
      App.setEnabled($btn, true);

      var data = App.parseError(jqXHR);
      if (data && _.has(data.error, 'message')) {
        if (data.error.validation) {
          return App.validateErrorAlert(data.error.validation);
        }
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    });
  },
  cancelUnregister: function(event) {
    // 退会ボタンが押せなくなっている時は動作させない
    var $unregister_btn = $(event.currentTarget).next();
    if (! App.isEnabled($unregister_btn)) {
      return;
    }
    // ページを戻す
    location.href = 'mamariq://back_to_top';
  },
  showTextarea: function(e) {
    var $radio = $(e.currentTarget);
    var $textareaBox = $('.js-unregister-textarea-box');
    $('.js-unregister-reason-detail-label', $textareaBox).html($radio.data('reasonDetailLabel'));
    $('textarea[name="reason-detail"]', $textareaBox).attr('placeholder', $radio.data('reasonDetailPlaceholder'));
    $textareaBox.show();
  },
  showSleepTimerPopup: function(data, $btn) {
    // おやすみモードを推奨するポップアップを表示
    var $popup = $('.js-suggest-sleep-mode-popup');
    $.fancybox($popup, { closeBtn: false });

    $('.js-suggest-sleep-mode-popup__sleep-mode', $popup).click(function() {
      // おやすみモード設定画面を表示
      $.fancybox.close();
      // OSによって挙動を変えないといけない点に注意
      if (App.me.is_ios) {
        $('<a />', { href: '/settings/sleep_time?move_to=top' }).get(0).click();
      } else {
        location.href = '/settings/sleep_time?move_to=top';
      }
    });

    var _this = this;
    $('.js-suggest-sleep-mode-popup__unregister', $popup).click(function() {
      // 退会処理を実行
      $.fancybox.close();
      _this.requestUnregister(data, $btn);
    });
  }
});

Views.QuestionAdd = Views.Base.extend({
  el: '#question-add',
  events: {
    'click .add-btn' : 'addQuestion',
  },
  initialize: function() {
  },
  addQuestion: function() {
    var _this, $btn, category_id, content, post_data;
    _this = this;
    //$btn = $(event.currentTarget); // これだと#user-settings(this?)が$btnになってしまう
    $btn = this.$('.add-btn');
    if (!App.isEnabled($btn)) {
      return;
    }

    category_id = this.$('select[name="question-category-id"]').val();
    if (! category_id) {
      // Model validationとかでやった方が良い？
      alert('カテゴリを選択してください');
      return;
    }

    content = this.$('textarea[name="question-content"]').val();
    if (! content) {
      alert('質問を入力してください');
      return;
    }

    post_data = {
      "data[token]"                 : App.me.token,
      "data[Question][category_id]" : category_id,
      "data[Question][content]"     : content,
    };

    App.changeText($btn, "通信中...");
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/question/add.json',
      data: post_data
    }).done(function(json) {
      //alert('質問を投稿しました。');
      location.href = '/question/' + json.response.Question.id;
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        //App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
});

Views.QuestionDelete = Views.Base.extend({
  el: '.question-self-delete',
  events: {
    'click' : 'deleteQuestion', // 自身にbind
  },
  deleteQuestion: function(event) {
    var _this, $btn, post_data;
    _this = this;
    $btn = $(event.currentTarget);

    if (! window.confirm('本当に削除してもよろしいですか？(※500ママリptを消費します)')) {
      return;
    }

    if (!App.isEnabled($btn)) {
      return;
    }

    post_data = {
      "data[token]"      : App.me.token,
      "data[Question][id]" : $btn.attr('question-id'),
    };

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/question/remove.json',
      data: post_data
    }).done(function(json) {
      alert('質問を削除しました');
      // mixpanelにデータ送信
      mixpanel.track("QuestionDelete");
      // Androidはlocation.reloadが効かないのでURLスキームを叩く
      if (App.me.is_ios) {
        location.reload(true);
      } else {
        location.href = 'mamariq://reload';
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.setEnabled($btn, true);
    });
  },
});

Views.QuestionScrollHeader = Views.Base.extend({
  el: '.question-scroll-header-wrapper',
  'question_id': null,
  scrollToAnchor: function(target_id) {
    var scroll_to;
    scroll_to = $('#' + target_id).offset().top;
    $('html,body').animate({scrollTop: scroll_to}, {duration: 'slow', easing: 'swing'});
  },
  render: function(content) {
    var _this, $content, $user_name;
    _this      = this;
    // ユーザー名表記の変更、お気に入りボタンのrm
    $content   = $(content).clone();
    $content.find('.question-show__header__fav-wrapper').remove();
    $user_name = $content.find('.question-show__header__questioner__link');
    $user_name.text($user_name.text() + 'さんの質問');
    this.$el.find('.question-scroll-header').html($content);

    $content.click(function(event) {
      event.preventDefault();
      _this.scrollToAnchor('question-' + _this.question_id);
    });
  },
  show: function() {
    // 現在の状態を監視して、animateが繰り返し適用されて意図しない挙動になるのを防ぐ。
    if (this.$el.css('top') === '-42px') {
      this.$el.animate({
        top: 0,
      }, 100, 'linear');
    }
  },
  hide: function() {
    // 現在の状態を監視して、animateが繰り返し適用されて意図しない挙動になるのを防ぐ。
    if (this.$el.css('top') === '0px') {
      this.$el.animate({
        top: '-42px',
      }, 100, 'linear');
    }
  }
});

Views.ReveilSensitiveImage = Views.Base.extend({
  el: '.js-reveil-question-sensitive-img-btn',
  events: {
    click: 'reveil'
  },
  reveil: function(event) {
    event.preventDefault();
    if (! confirm('本当に画像を表示してよろしいですか？')) {
      return;
    }
    var $img = $('<img>')
      .attr('src', this.$el.data('imgSrc'))
      .addClass('question_show__content__thumb');
      this.$el.replaceWith($img);
  }
});

Views.AnswerAdd = Views.Base.extend({
  el: '.answer-form',
  events: {
    'click .add-btn' : 'addAnswer',
  },
  initialize: function() {
  },
  addAnswer: function() {
    var _this, $btn, content, post_data;
    _this = this;
    //$btn = $(event.currentTarget); // これだと#user-settings(this?)が$btnになってしまう
    // funtctionの引数にeventを指定してないからだったっぽい
    $btn = this.$('.add-btn');
    if (!App.isEnabled($btn)) {
      return;
    }

    content = this.$('textarea[name="answer-content"]').val();
    if (! content) {
      alert('回答を入力してください');
      return;
    }

    post_data = {
      "data[token]"               : App.me.token,
      "data[Answer][question_id]" : this.$('input[name="answer-question-id"]').val(),
      "data[Answer][content]"     : content,
    };

    App.changeText($btn, "通信中...");
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/answer/add.json',
      data: post_data
    }).done(function(json) {
      // mixpanel
      var question_user_id =   json.response.Question.user_id;
      var answer_user_id   =   json.response.Answer.user_id;
      var is_contain_image = !!json.response.Answer.image;
      var is_soku_res      = !!json.response.Answer.is_soku_res;
      if (question_user_id === answer_user_id) {
          mixpanel.track("ReplyAdd",  {"IsContainImage": is_contain_image});
          mixpanel.people.increment("ReplyAddCount", 1);
      } else {
          mixpanel.track("AnswerAdd", {"IsContainImage": is_contain_image,"IsQuick": is_soku_res});
          mixpanel.people.increment("AnswerAddCount", 1);
      }

      var datetime_msec = +new Date(); // 日付オブジェクトは、四則演算するときに自動的にミリ秒変換して数値として計算する
      var url = location.pathname + '?' + json.response.Answer.id + datetime_msec;
      location.href = url;
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
});

// 質問詳細 いいねボタン
Views.LikeAdd = Views.Base.extend({
  el: '.like',
  events: {
    touchstart: 'onTouchStart',
    touchmove: 'onTouchMove',
    touchend: 'addLike'
  },
  timer: null,
  likeCount: 0,
  popupCloseDelay: 700,
  tapTimeLimit: 600,
  onTouchStart: function() {
    $(event.currentTarget).data('scrolled', false);
  },
  onTouchMove: function() {
    $(event.currentTarget).data('scrolled', true);
  },
  incrementLike: function(element) {
    var count = element.text();
    if (_.isEmpty(count)) {
      return element.text(1);
    }
    element.text(parseInt(count) + 1);
  },
  decrementLike: function(element) {
    var count = element.text();
    if (count <= 1) {
      element.text('');
      return;
    }
    element.text(parseInt(count) - 1);
  },
  addLike: function() {
    var $btn = $(event.currentTarget);
    if ($btn.data('scrolled')) {
      return;
    }

    // ゲストユーザーはポップアップを表示する
    if (!App.me.is_login) {
      location.href = 'mamariq://require_register?trigger=LikeQuestion';
      return;
    }

    // 自分の回答の場合はlikeできない
    if ($btn.attr('user-id') === App.me.User.id) {
      return;
    }

    // いいね済みか
    var isLiked = $btn.hasClass('liked');
    // API送信済みか
    if ($btn.data('submitted-api') == null) {
      $btn.data('submitted-api', isLiked);
    }

    // いいね数格納要素
    var likeValue = $btn.find('.p-answer-like__value');
    if (likeValue.length < 1) {
      // 要素がなければ生成
      $btn.append(' <span class="p-answer-like__value"></span>');
      likeValue = $btn.find('.p-answer-like__value');
    }

    var $icon = $btn.find('.p-answer-like__icon');
    if (isLiked/* @todo 回答の件数が増えると重いので封印 && this.likeCount < 1 */) {
      // いいね済み & 連打中でない
      $btn.removeClass('liked');
      // $icon.removeClass('liked--animation p-answer-like__icon--active');
      $icon.removeClass('p-answer-like__icon--active');
      return;
    }

/* @todo 回答の件数が増えると重いので封印
    if (this.timer != null) {
      $icon.removeClass('liked--animation');
    }

    // カウントアップ
    this.likeCount++;
//*/

    var _this = this;
    $btn.addClass('liked');
    // @todo 回答の件数が増えると重いので暫定対応
    // $icon.addClass('liked--animation p-answer-like__icon--active');
    $icon.addClass('p-answer-like__icon--active');

/* @todo 回答の件数が増えると重いので封印
    $icon.removeClass('liked--animation', 0, null, function() {
      // @todo アニメーションの非同期実行
      $icon.addClass('p-answer-like__icon--active liked--animation');

      // タイマー動作中か
      if (_this.timer != null) {
        // リセットする
        clearTimeout(_this.timer);
        _this.timer = null;
      }

      // タイマーを設定
      _this.timer = setTimeout(function() {
        if (_this.likeCount > 1) {
          // 連打ならポップアップを表示
          $('.js-liked-popup-count').text(_this.likeCount);
          // ポップアップをタップされたら閉じる
          var popup = $('.js-liked-popup');
          popup.on('touchend', $.fancybox.close);
          $.fancybox(popup, {
            closeBtn: false,
            closeClick: true,
            helpers: {
              overlay: {
                closeClick: true,
                locked: true
              }
            },
            afterShow: function() {
              setTimeout($.fancybox.close, _this.popupCloseDelay);
            }
          });
        }
        // mixpanel (いいね連打数)
        mixpanel.track('LikeAddRepeatCount', {count: _this.likeCount});
        // 連打回数をリセット
        _this.likeCount = 0;
      }, _this.tapTimeLimit);
    });
//*/

    if ($btn.data('submitted-api')) {
      // 送信済みなら終了
      return;
    }
    // いいね済みにする
    $btn.data('submitted-api', true);
    this.incrementLike(likeValue);

    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid
      },
      url: '/api/like/add.json',
      data: {
        'data[token]': App.me.token,
        'data[Like][answer_id]': $btn.attr('answer-id')
      }
    }).done(function() {
      // いいね済みにする
      $btn.data('submitted-api', true);
      // mixpanel (いいね)
      mixpanel.track('LikeAdd');
    }).fail(function(jqXHR) {
      // いいね数を減らす
      _this.decrementLike(likeValue);

      var data = App.parseError(jqXHR);
      if (!data || !_.has(data.error, 'message')) {
        return App.networkErrorAlert();
      }
      if (data.error.validation) {
        return App.validateErrorAlert(data.error.validation);
      }
      alert(data.error.message);
      return;
    }).always(function(){
      App.restoreText($btn);
    });
  }
});


// 質問詳細 ありがとうボタン
Views.ThankAdd = Views.Base.extend({
  el: '.thank',
  events: {
    'click' : 'addThank',
  },
  addThank: function(event) {
    var _this, $answer, $btn, $like_count, is_thanked, post_data, thank_num;
    _this   = this;
    $btn    = $(event.currentTarget);
    $answer = $btn.closest('.answer__list'); // 回答コメントの親要素を取得する

    // ありがとうボタンが有効かどうか
    if (! App.isEnabled($btn)) {
      return;
    }

    // 既にユーザーがthankしている場合は再度likeはできない
    is_thanked = $btn.hasClass('thanked');
    if (is_thanked) {
      return;
    }

    // 自分の回答の場合はlikeできない
    if ($btn.attr('user-id') === App.me.User.id) {
      return;
    }

    // 未Like、自分の回答ではない場合、いいねボタンのclassを追加
    $btn.addClass('thanked');

    // いいね数を増やす
    $like_count = $answer.find('.like-count');
    thank_num   = parseInt($like_count.text()) + 1;
    $like_count.text(thank_num);

    post_data = {
      "data[token]"           : App.me.token,
      "data[Like][answer_id]" : $btn.attr('answer-id')
    };

    // ありがとうボタンを無効化する
    App.setEnabled($btn, false);

    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/like/add.json',
      data: post_data
    }).done(function(json) {
      mixpanel.track("ThankAdd");
    }).fail(function(jqXHR, textStatus, errorThrown) {
      // ありがとうボタンを押されていない状態に戻す
      $btn.removeClass('thanked');
      // ありがとうボタンを有効化する
      App.setEnabled($btn, true);
      // いいね数を減らす
      if (parseInt($like_count.text()) > 1) {
        thank_num = parseInt($like_count.text()) - 1;
        $like_count.text(thank_num);
      } else {
        $like_count.text('0');
      }
      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
});


// グッドアンサーボタン
Views.BestAnswerAdd = Views.Base.extend({
  el: '.best-answer',
  events: {
    'click' : 'addBest', // 自身にbind
  },
  addBest: function() {
    var _this, $btn, $all_btn, is_best_answered, post_data;
    _this = this;
    $btn = $(event.currentTarget);

    if (! window.confirm('この回答を「グッドアンサー」に選びます。よろしいですか？')) {
      return;
    }

    if (!App.isEnabled($btn)) {
      return;
    }

    post_data = {
      "data[token]"      : App.me.token,
      "data[Answer][id]" : $btn.attr('answer-id'),
    };

    $all_btn = $(this.el); // これだとすべての.best-answerが取れる
    App.setEnabled($all_btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/answer/best.json',
      data: post_data
    }).done(function(json) {
      var should_show_review_popup;
      $(".best-answer").hide();
      $btn.closest('.other-reply').addClass('best-answer-selected');

      // mixpanelにデータ送信
      mixpanel.track("BestAnswer");

      // レビューポップアップを出すか確認
      should_show_review_popup = json.response.should_show_review_popup;
      if (should_show_review_popup && !_this.hasExperiencedReviewPopup()) {
        _this.showSuggestReviewPopup();
      } else {
        alert('グッドアンサーを決定しました！');
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.setEnabled($all_btn, true);
    });
  },
  showSuggestReviewPopup: function() {
    var $popup;
    mixpanel.track('ReviewPopupShow');

    $popup = $('.js-suggest-review-best-answer-selected');
    $.fancybox($popup, {
      closeBtn : false,
    });

    // レビューを書く
    $('.js-suggest-review-best-answer-selected__review', $popup).click(function() {
      var store_url;
      if (App.me.is_ios) {
        store_url = 'https://itunes.apple.com/jp/app/id867414015';
      } else {
        store_url = 'https://play.google.com/store/apps/details?id=com.connehito.mamariq';
      }
      // iOSは仮想DOMでクリックイベントを起こす
      if (App.me.is_ios) {
        $('<a></a>', {
          href: store_url
        }).get(0).click();
      } else {
        location.href = store_url;
      }
      $.fancybox.close();
      mixpanel.track('ReviewPopupReview');
    });

    // キャンセル
    $('.js-suggest-review-best-answer-selected__cancel', $popup).click(function() {
      $.fancybox.close();
      mixpanel.track('ReviewPopupDeny');
    });
    localStorage.setItem('review_popup_experienced', Date.now());
  },
  hasExperiencedReviewPopup: function() {
    var review_popup_experienced;

    // ローカルストレージが使えない場合は常にtrueを返してポップアップを表示しない
    if (typeof localStorage === 'undefined') {
      return true;
    }

    review_popup_experienced = localStorage.getItem('review_popup_experienced');
    // ポップアップを表示した記録がない場合は未経験
    if (typeof review_popup_experienced === 'undefined') {
      return false;
    }

    // ポップアップを表示してから2ヶ月経っていれば表示する
    if (review_popup_experienced < (Date.now() - (86400 * 1000 * 60))) {
      return false;
    }

    return true;
  }
});

Views.Favorite = Views.Base.extend({
  el: '.q-favorite',
  events: {
    'click' : 'changeFavoriteStatus', // 自身にbind
  },
  changeFavoriteStatus: function(event) {
    var _this, $btn, is_favorited, post_data, api_url;
    _this = this;
    $btn = $(event.currentTarget);
    if (!App.isEnabled($btn)) {
      return;
    }

    // ゲストユーザーはポップアップを表示する
    if (! App.me.is_login) {
      location.href = 'mamariq://require_register?trigger=FavoriteQuestion';
      return;
    }

    // 自分の質問の場合はお気に入りできない
    if ($btn.attr('question-user-id') === App.me.User.id) {
      return;
    }

    post_data = {
      "data[token]"                 : App.me.token,
      "data[Favorite][question_id]" : $btn.attr('question-id'),
    };

    api_url = '/api/favorite/add.json';
    // 既にユーザーがお気に入りしている場合はremove APIを叩き、お気に入りを取り消す
    is_favorited = $btn.hasClass('is-favorited');
    if (is_favorited) {
      api_url = '/api/favorite/remove.json';
    }

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: api_url,
      data: post_data
    }).done(function(json) {
      if (! is_favorited) {
        $btn.addClass('is-favorited');
        mixpanel.track("FavoriteAdd");
      } else {
        $btn.removeClass('is-favorited');
        mixpanel.track("FavoriteDelete");
      }

    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
});

// ブロック一覧 ブロック機能
Views.BlockingUserList = Views.Base.extend({
  el: '.user-blocking__list__btn',
  events: {
    'click' : 'changeBlockStatus', // 自身にbind
  },
  changeBlockStatus: function(event) {
    var _this, $btn, api_url, is_blocking, post_data;
    _this   = this;
    api_url = '/api/relation/unblock.json'; // ブロック解除するAPI

    // ブロック機能が実行可能であるかどうか
    $btn = $(event.currentTarget);
    if (! App.isEnabled($btn)) {
      return;
    }

    post_data = {
      "data[token]"                    : App.me.token,
      "data[Relation][target_user_id]" : $btn.attr('target-user-id'), // target-user-id="user_id"のブロックステータスを変更する
    };

    // ブロックしていない場合 (is_blocking = false) はブロックAPIを叩く
    is_blocking = $btn.hasClass('is-blocking');
    if (! is_blocking) {
      api_url = '/api/relation/block.json';
    }

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url  : api_url,
      data : post_data
    }).done(function(json) {
      if (is_blocking) {
        // ブロック解除する
        $btn.removeClass('is-blocking');
        $btn.addClass('user-blocking__list__btn--off');
        $btn.text("ブロック");

        mixpanel.track('Unblock');
      } else {
        // ブロックする
        $btn.removeClass('user-blocking__list__btn--off');
        $btn.addClass('is-blocking');
        $btn.text("解除する");

        mixpanel.track('Block');
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function() {
      App.restoreText($btn);
      App.setEnabled($btn, true);
    });
  },
});

// ユーザーページ ブロック機能
Views.Block = Views.Base.extend({
  el: '.p-profile-header__meta__block',
  events: {
    'click' : 'changeBlockStatus'
  },
  changeBlockStatus: function(event) {
    // 多重送信防止
    const $btn = $(event.currentTarget)
    if (!App.isEnabled($btn)) {
      return
    }

    // ブロックしていない場合は確認アラートを表示
    const isBlocking = $btn.hasClass('is-blocking')
    const message = 'このユーザーをブロックします。本当によろしいですか？\n今後このユーザーの質問・回答が非表示になります。ブロックした相手も、あなたの質問・回答が表示されなくなります。なお、この設定は相手には通知されません。';
    if (!isBlocking && !window.confirm(message)) {
      return
    }

    const apiUrl = isBlocking ? '/api/relation/unblock.json' : '/api/relation/block.json'
    const blockedUserId = $btn.attr('target-user-id')
    App.setEnabled($btn, false)
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid
      },
      url: apiUrl,
      data: {
        'data[token]': App.me.token,
        'data[Relation][target_user_id]': blockedUserId
      }
    }).done(function() {
      if (isBlocking) {
        // ブロックを解除する
        $btn.removeClass('p-profile-header__meta__block--on is-blocking')

        mixpanel.track('Unblock')
        tracker.track('Unblock', {
          UnblockedUserId: blockedUserId
        })
      } else {
        // ブロックする
        $btn.addClass('p-profile-header__meta__block--on is-blocking')

        mixpanel.track('Block')
        tracker.track('Block', {
          BlockedUserId: blockedUserId
        })
      }
    }).fail(function(jqXHR) {
      var data = App.parseError(jqXHR)
      if (!data) {
        App.networkErrorAlert()
        return
      }

      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation)
        } else {
          alert(data.error.message)
        }
        return
      }

      App.networkErrorAlert()
    }).always(function() {
      App.restoreText($btn)
      App.setEnabled($btn, true)
    })
  }
})

// 削除ボタン
Views.AnswerDelete = Views.Base.extend({
  el: '.answer-self-delete',
  events: {
    'click' : 'deleteAnswer', // 自身にbind
  },
  deleteAnswer: function(event) {
    var _this, $btn, post_data;
    _this = this;
    $btn = $(event.currentTarget);

    if (! window.confirm('本当に削除してもよろしいですか？')) {
      return;
    }

    if (!App.isEnabled($btn)) {
      return;
    }

    post_data = {
      "data[token]"      : App.me.token,
      "data[Answer][id]" : $btn.attr('answer-id'),
    };

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/answer/remove.json',
      data: post_data
    }).done(function(json) {
      alert('回答を削除しました');
      // mixpanelにデータ送信
      mixpanel.track("AnswerDelete");
      // Androidはlocation.reloadが効かないのでURLスキームを叩く
      if (App.me.is_ios) {
        location.reload(true);
      } else {
        location.href = 'mamariq://reload';
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.setEnabled($btn, true);
    });
  },
});

// タグのフォロー機能
Views.FollowTag = Views.Base.extend({
  el: '.p-follow-tag-btn',
  events: {
    'touchstart' : 'changeFollowTagStatus', // 自身にbind
  },
  changeFollowTagStatus: function(event) {
    var _this, $btn, api_url, is_followed, post_data, tag_id;

    _this       = this;
    $btn        = $(event.currentTarget);
    api_url     = '/api/follow_tag/add.json';
    is_followed = $btn.hasClass('p-follow-tag-btn--on');
    tag_id      = $btn.attr('tag-id');
    post_data   = {
      "data[token]"             : App.me.token,
      "data[FollowTag][tag_id]" : tag_id,
    };

    // フォローボタンが有効でない場合
    if (! App.isEnabled($btn)) {
      return;
    }

    // ゲストユーザーはポップアップを表示する
    if (! App.me.is_login) {
      location.href = 'mamariq://require_register?trigger=FollowTag';
      return;
    }

    // 既にユーザーがフォローしている場合、removeAPIを叩いてお気に入りを取り消す
    if (is_followed) {
      api_url = '/api/follow_tag/remove.json';
    }

    App.setEnabled($btn, false);

    $.ajax({

      type    : 'POST',
      headers : { 'X-MAMARIQ-UUID' : App.me.User.uuid },
      url     : api_url,
      data    : post_data,

    }).done(function(json) {

      // is_followedを関数内でわかりやすくするため、is_addかどうかを明示的に示す
      var is_add = ! is_followed;

      if (is_add) {
        // フォローする
        $btn.addClass('p-follow-tag-btn--on');

        // Mixpanelでトラック
        mixpanel.track("FollowTagAdd", {"TagId" : tag_id});
      } else {
        // フォロー解除
        $btn.removeClass('p-follow-tag-btn--on');

        // Mixpanelでトラック
        mixpanel.track("FollowTagRemove", {"TagId" : tag_id});
      }

    }).fail(function(jqXHR, textStatus, errorThrown) {

      var data = App.parseError(jqXHR);

      // 異常終了した場合、アラートを返す
      if (! data) {
        App.networkErrorAlert();
        return;
      }

      if ( _.has(data.error, 'message') ) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message);
        }
        return;
      }

      App.networkErrorAlert();

    }).always(function() {

      App.setEnabled($btn, true);

    });
  },
});


Views.SocialPointAdd = Views.Base.extend({
  el: '.js-point-share-btn',
  events: {
    'click' : 'addPoint', // 自身にbind
  },
  addPoint: function(event) {
    var _this, $btn, post_data, share_id, url_scheme;
    _this      = this;
    $btn       = $(event.currentTarget);
    share_id   = $btn.attr('share-id');
    url_scheme = $btn.attr('url-scheme');

    if (!App.isEnabled($btn)) {
      return;
    }

    post_data = {
      "data[token]"            : App.me.token,
      "data[GetPoint][etc_id]" : share_id
    };

    // pointをついかできたかどうかに関わらずシェアの画面遷移を起こす。
    location.href = url_scheme;

    // Mixpanelでトラック
    mixpanel.track("PointShare", {"ShareId" : share_id});

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/get_point/share.json',
      data: post_data
    }).done(function(json) {
      // 特に成功してもアクションはない
      // 2015/6/15現在、アンパンキャンペーンでしか使わないのでキャンペーン用の文言にする
      alert('500ポイントGET！今すぐキャンペーンに応募しよう！');
    }).fail(function(jqXHR, textStatus, errorThrown) {
      // 2回目以降のシェアはポイントが入らないというエラーが返ってくる。
      // その状態でも問題なくシェアが行われるよう、エラーでも特にエラーは出さない。
    }).always(function(){
      App.setEnabled($btn, true);
    });
  },
});

// 違反報告ポップアップ表示
Views.ViolationReport = Views.Base.extend({
  el: '.report-violation-icon',
  events: {
    'click': 'showPopUp' // 自分自身にbind
  },
  initialize: function() {
    var $contentWrapper = this.$el.closest('.infinity-scroll-content-wrapper');
    var violationReportCategory = new Views.ViolationReportCategory({
      el: $contentWrapper.find(Views.ViolationReportCategory.prototype.el)
    });
    violationReportCategory.$contentWrapper = $contentWrapper;
  },
  showPopUp: function(event) {
    var $btn = $(event.currentTarget);
    var $contentWrapper = this.$el.closest('.infinity-scroll-content-wrapper');
    var $reportBtn = $contentWrapper.find('.report-violation-pop-up-category__report-btn');

    // 値をセット
    $reportBtn.attr({
      etc_id: $btn.attr('etc-id'),
      target_user_id: $btn.attr('target-user-id'),
      type_id: $btn.attr('type-id')
    });

    // pop-up表示
    $.fancybox($reportBtn.closest('.report-violation-pop-up-category'), {
      beforeShow: function() {
        // 初期化する
        $("input[name='report-violation-category']").attr('checked', false);
        $("input[name='report-question-category']").attr('checked', false);
        $('.js-report-question-category').toggle($btn.hasClass('js-report-violation-question'));
        $('.js-violation-categories').show();
        $('.js-question-categories').hide();
      },
      // for iOS9 bug, obtained from https://github.com/fancyapps/fancyBox/issues/1068 */
      afterShow: function() {
        $('.fancybox-opened').css('transform', 'translateZ(100px)');
      },
      afterClose: function() {
        $('.fancybox-opened').css('transform', 'none');
      }
    });
  }
});

// 違反報告送信
Views.ViolationReportCategory = Views.Base.extend({
  el: '.report-violation-pop-up-category',
  events: {
    'click .report-violation-pop-up-category__report-btn': 'reportViolation'
  },
  props: {
    messages: {
      alertViolationType: '違反報告の種類を選択してください',
      alertQuestionCategory: '変更先のカテゴリを選択してください',
      confirmSubmit: '違反報告を行います。本当によろしいですか？'
    }
  },
  reportViolation: function(event) {
    var $btn = $(event.currentTarget);
    if (!App.isEnabled($btn)) {
      // すでに処理中なら処理を中止する
      return;
    }

    var $contentWrapper = this.$contentWrapper;
    var violationCategoryId = this.$("input[name='report-violation-category']:checked").val();
    if (typeof violationCategoryId === 'undefined') {
      // カテゴリ未選択の場合
      alert(this.props.messages.alertViolationType);
      return;
    }

    var data = {
      'data[token]': App.me.token,
      'data[Violation][etc_id]': $btn.attr('etc_id'),
      'data[Violation][target_user_id]': $btn.attr('target_user_id'),
      'data[Violation][type]': $btn.attr('type_id'),
      'data[Violation][category_id]': violationCategoryId,
      'data[Violation][content]': ''
    };

    if (violationCategoryId === '2') {
      // 間違ったカテゴリへの質問
      var $questionCategories = $('.js-question-categories');
      if ($questionCategories.is(':visible')) {
        var questionCategoryId = $("input[name='report-question-category']:checked").val();
        if (typeof questionCategoryId === 'undefined') {
          alert(this.props.messages.alertQuestionCategory);
          return;
        }
        if (!window.confirm(this.props.messages.confirmSubmit)) {
          return;
        }
        data['data[ViolationCategory][category_id]'] = questionCategoryId;
        App.setEnabled($btn, false);
        return this.callViolationApi($contentWrapper, $btn, data);
      }

      // カテゴリ選択を表示
      $('.js-violation-categories').hide();
      $('.js-question-categories').show();
      return;
    }

    if (!window.confirm(this.props.messages.confirmSubmit)) {
      return;
    }

    App.setEnabled($btn, false);
    this.callViolationApi($contentWrapper, $btn, data);
  },
  callViolationApi: function($contentWrapper, $btn, data) {
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID' : App.me.User.uuid
      },
      url: '/api/violation/add.json',
      data: data
    }).done(function(json) {
      var violation = json.response.Violation;

      // mixpanelにデータ送信
      var content;
      if (violation.type === '0') {
        content = $contentWrapper.find('.js-question-content').text();
        mixpanel.track('ViolateQuestion');
      } else {
        content = $contentWrapper.find('.js-answer-content' + '[answer-id=' + violation.etc_id + ']').text();
        mixpanel.track('ViolateAnswer')
      }

      // mailtoの文言を作成して、設定
      var mailtoText =  $contentWrapper.find('.report-violation-pop-up__mailto').data('preHref');
      mailtoText += encodeURIComponent(content);
      $contentWrapper.find('.report-violation-pop-up__mailto').attr({'href' : mailtoText});

      // 報告に対して、お礼のメッセージを出す
      $.fancybox($contentWrapper.find('.report-violation-pop-up-thanks'), {
        afterShow: function() {
          $('.fancybox-opened').css('transform', 'translateZ(100px)');
        },
        afterClose: function() {
          $('.fancybox-opened').css('transform', 'none');
        }
      });
    }).fail(function(jqXHR) {
      var data = App.parseError(jqXHR);
      if (data && _.has(data.error, 'message')) {
        if (data.error.validation) {
          return App.validateErrorAlert(data.error.validation);
        }
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    }).always(function() {
      App.setEnabled($btn, true);
    });
  }
});


Views.QuestionLoad = Views.Base.extend({
  initialize: function() {
    // 最初にgetQuestions()を実行して、最初の質問を取得した後で、 スクロールがボトムに近くなるとgetQuestions()が呼ばれる処理をセットする
    // 参考URL: http://arakaze.ready.jp/archives/1041
    $.when(
      this.getQuestions()
    ).done(
      this.setBottomLoadEvent()
    );
  },
  events: {
    'click .see-more-btn' : 'getQuestions',
  },

  offset: 9000000000000000000, // PHP_INT_MAXの2桁以降を0にした(環境によってPHP_INT_MAXの値が違うため) php側ではmamari_php_ini_maxとして宣言
  limit: 50,
  page: 0,
  is_finish: false,
  is_getting_question: false,
  question_count: 0,
  setBottomLoadEvent: function() {
    var _this, scrollHeight, scrollPosition;
    _this = this;
    $(window).bind("scroll", function() {
      scrollHeight   = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      // スクロールの位置が下部20%の範囲に来た場合
      if ((scrollHeight - scrollPosition) / scrollHeight <= 0.2) {
        _this.getQuestions();
      }
    });
  },
  getQuestions: function() {
    var _this, $question_list, api_url, category_id, headers, params, tag_id;
    _this          = this;
    $question_list = $('.js-q-list');
    // Q取得中
    if (this.is_getting_question) {
      return;
    }
    // 取得できるQをすべて取得したかどうか
    if (this.is_finish) {
      return;
    }

    this.is_getting_question = true;

    params = {
      'offset' : this.offset,
      'limit'  : this.limit
    };

    if (App.init_fn.action === 'index') {
      api_url = '/api/question/top.json';
    } else if (App.init_fn.action === 'category') {
      api_url = '/api/question/top.json';
      category_id = location.pathname.match(/[0-9]+$/)[0];
      params['category_id'] = category_id;
    } else if (App.init_fn.action === 'region') {
      api_url = '/api/question/region.json';
    } else if (App.init_fn.action === 'answers') {
      api_url = '/api/question/answered.json';
      params['user_id'] = App.me.User.id;
    } else if (App.init_fn.action === 'questions') {
      api_url = '/api/question/asked.json';
    } else if (App.init_fn.action === 'favorites') {
      api_url = '/api/question/favorited.json';
    } else if (App.init_fn.action === 'unanswered') {
      api_url = '/api/question/unanswered.json';
    } else if (App.init_fn.controller === 'Tags'  && App.init_fn.action === 'show') {
      api_url = '/api/question/tag.json';
      tag_id = location.pathname.match(/[0-9]+$/)[0];
      params['tag_id'] = tag_id;
    }

    // ログインしている場合はUUIDをheaderに付ける
    if (App.me.is_login) {
      headers = {'X-MAMARIQ-UUID': App.me.User.uuid};
    } else {
      headers = {};
    }
    $.ajax({
      type: 'GET',
      headers: headers,
      url:  api_url,
      beforeSend: function(xhr) {
        $(".loading-bottom-gif-wrapper").show();
      },
      data: params
    }).done(function(json) {
      // 最後まで読み終わったときの処理
      if (json.response.length === 0) {
        _this.is_finish = true;
        return;
      }

      var shouldHideUnansweredQuestions = false;
      if (App.me.is_login && App.init_fn.action === 'index') {
        // アプリ登録後1週間以内のユーザーに対し、
        // TOPページでは未回答の質問を見せない
        var userCreated = new Date(App.me.User.created.replace(' ', 'T'));
        var userCreatedTs = userCreated.getTime();
        shouldHideUnansweredQuestions= (userCreatedTs >= Date.now() - 604800000); // 60 * 60 * 24 * 7;
      }
      _.each(json.response, function(data){
        var html;
        html = new Views.Question().render(data);
        _this.offset = Math.min(data.Question.id, _this.offset);
        var isHiddenQuestion = false;

        if (data.Question.answer_count === '0' &&
            shouldHideUnansweredQuestions &&
            data.Question.user_id !== App.me.User.id
           ) {
          // 未回答の質問は登録後間もないユーザーには出さない
          isHiddenQuestion = true;
        }
        if (data.User.is_violating || data.Question.is_violating) {
          // 違反ユーザーの質問のとき or 違反質問のとき
          if (! App.me.is_login) {
            // 閲覧者がログインしていていない場合、違反者の質問は見せない
            isHiddenQuestion = true;
          }
          else if (data.User.id !== App.me.User.id) {
            // ログインしていても、違反ユーザー自身以外の場合は質問を見せない
            // 逆に言うと違反ユーザーには自身の質問を見せる
            isHiddenQuestion = true;
          }
        }

        if (isHiddenQuestion) {
          return;
        }

        // 避妊カテを非表示に設定している場合は、避妊カテのQuestionを表示しない
        if (data.Question.category_id === '10' && App.me.User.is_contraception_visible === false) {
          return;
        }

        // Questionの追加前にPR記事を追加するかチェック
        var articleIndex = Math.floor((_this.question_count - 1) / 5);
        var isInsertIndex = (_this.question_count > 0 && _this.question_count % 5 === 0);
        var articles = App.vars.sponsored_articles;
        var controller = App.init_fn.controller;
        var action = App.init_fn.action;
        var isTop = (controller === 'Etc' && action === 'index');
        if (isTop && isInsertIndex && articles.length > articleIndex) {
          var articleData = {
            article: articles[articleIndex],
            adSlot: controller + '-' + action + '-' + _this.question_count
          }
          var articleHtml = new Views.SponsoredArticle().render(articleData);
          $question_list.append(articleHtml.$el);
        }

        // Questionを追加
        $question_list.append(html.$el);
        _this.question_count++;
      });

      // 2ページ目以降はPVを計測する
      _this.page++;
      if (_this.page >= 2) {
        ga('mamari_common.set', {page: location.pathname + '?page=' + _this.page});
        ga('mamari_q.set', {page: location.pathname + '?page=' + _this.page});
        ga('mamari_common.send', 'pageview');
        ga('mamari_q.send', 'pageview');
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        //App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      _this.is_getting_question = false;
      $(".loading-bottom-gif-wrapper").hide();
    });
  }
});

Views.SponsoredArticle = Views.Base.extend({
  className: 'question-card__list',
  tagName: 'li',
  template: App.Templates.sponsored_article,
  render: function(content) {
    var html;
    html = this.template(content);
    this.$el.html(html);
    return this;
  }
});

Views.Question = Views.Base.extend({
  className: 'c-question-list__item',
  tagName: 'li',
  template: App.Templates.question,
  render: function(content) {
    // 回答ステータスの文言設定
    content.answeredStatus = this.getAnsweredStatusLabel(content.Question)
    // 子供情報の設定
    content.hasChild = content.Child.length > 0
    content.Child = content.Child.map(child => {
      const className = this.getChildSexClassName(child)
      child.className = className ? `c-question-list__item__detail__user__name__child__list--${className}` : ''
      return child
    })

    this.$el.html(this.template(content))
    return this
  },
  getAnsweredStatusLabel: function(question) {
    if (question.is_closed) {
      return '締切済み'
    }
    if (question.answered_status === '0') {
      return '未回答'
    }
    return null
  },
  getChildSexClassName(child) {
    switch (child.sex) {
      case '0':
        return child.is_born ? '' : 'unknown'
      case '1':
        return 'boy'
      case '2':
        return 'girl'
      default:
        return ''
    }
  }
});

Views.QuestionInfinityScroll = Views.Base.extend({
    el: '.infinity-scroll-content-wrapper:last',
    events: {
      "click .link-to-bottom" : "scrollToBottom",
      "click .link-to-top" : "scrollToTop"
    },
    initialize: function() {
      if (! localStorage.getItem('exclude_question_list')) {
        localStorage.setItem('exclude_question_list', '[]');
      }
    },
    appendQuestion: function(event, target_url) {
      var _this, question_id;
      _this = this;

      if (! target_url) {
        return;
      }
      question_id = this.extractQuestionId(target_url);
      this.$el.data('questionId', question_id);
      this.pushExcludeQuestionList(question_id);
      this.loadQuestion(target_url).done(function(data) {
        _this.render(data);
        _this.onSuccess(target_url);

      // ネットワーク等の例外
      }).fail(function(jqXHR, text_status, error_thrown) {
        // ユーザーに対して行うべき通知はないので、何もしない(アラート等すると邪魔になりそう)
      });
    },
    // サーバーに対して追加で読み込ませる用の記事をリクエスト
    loadQuestion: function(url) {
      var data, exclude_question_list, headers;
      try {
        exclude_question_list = JSON.parse(localStorage.exclude_question_list);
      } catch (e) {
        exclude_question_list = [];
      }
      data = {
        token:            App.me.token,
        exclude_question: exclude_question_list.join(',')
      };

      // リクエストヘッダーにユーザー情報とアプリのバージョンの情報を付ける
      headers = {'X-MAMARIQ-UUID': App.me.User.uuid};
      if (App.me.is_ios) {
        headers['X-MAMARIQ-IOS-VERSION'] = App.me.app_version;
      } else {
        headers['X-MAMARIQ-ANDROID-VERSION'] = App.me.app_version;
      }

      return $.ajax({
        url:      url,
        type:     'POST',
        dataType: 'html',
        data:     data,
        headers:  headers
      });
    },
    // サーバーから取得した記事の内容をHTML上に挿入する
    render: function(content) {
      var _this, bind_views;
      _this   = this;
      content = $(content).find('.infinity-scroll-content-wrapper');//.index(0).html();
      this.$el.html(content.html());

      // 新しく追加したViewにイベントをbindしていく
      bind_views = [
        Views.AnswerDelete,
        Views.LikeAdd,
        Views.Favorite,
        Views.ViolationReport,
        Views.ReveilSensitiveImage
      ];
      _.each(bind_views, function(View) {
        new View({el: _this.$el.find(View.prototype.el)});
      });

      // 自分のQuestionはサーバー側で弾く
      //new Views.QuestionDelete();
      //new Views.ThankAdd();
      //new Views.BestAnswerAdd();
      return this;
    },
    // 処理が正常に成功した場合の処理
    onSuccess: function(targetUrl) {
      ga('mamari_common.set', {page: targetUrl});
      ga('mamari_common.send', 'pageview');
      ga('mamari_common.send', 'event', 'InfinityScroll', 'LoadQuestion', targetUrl);
      ga('mamari_q.set', {page: targetUrl});
      ga('mamari_q.send', 'pageview');
      ga('mamari_q.send', 'event', 'InfinityScroll', 'LoadQuestion', targetUrl);
      this.$el.data('isLoading', false);
    },
    // URLから記事IDを抜き出す
    extractQuestionId: function(pathname) {
      var question_id;
      question_id = pathname.split('/')[2];
      question_id = parseInt(question_id.split('?')[0]);
      return question_id;
    },
    // 既読記事IDリストに追加
    pushExcludeQuestionList: function(question_id) {
      var exclude_question_list;
      try {
        exclude_question_list = JSON.parse(localStorage.getItem('exclude_question_list'));
      } catch (e) {
        exclude_question_list = [];
      }
      exclude_question_list.unshift(question_id);
      exclude_question_list = _.uniq(exclude_question_list);
      exclude_question_list = exclude_question_list.slice(0, 5000);
      localStorage.setItem('exclude_question_list', JSON.stringify(exclude_question_list));
    },
    // @todo この辺りinit.jsと被るので集約したい。相談。
    // 下へスクロール
    scrollToBottom: function(event) {
        var answer_footer, scroll_to;
        const $answer_footer = $('.answer__footer', this.$el);
        scroll_to      = $answer_footer.offset().top + $answer_footer.height() + 10 - $(window).height();
        scroll_to      = Math.min(scroll_to, $answer_footer.offset().top);
        $('html,body').animate({scrollTop: scroll_to}, { duration: 'slow', easing: 'swing'});
    },
    // 上へスクロール
    scrollToTop: function(event) {
        var scroll_to;
        scroll_to = this.$el.offset().top;
        $('html,body').animate({ scrollTop: scroll_to }, { duration: 'slow', easing: 'swing'});
    }
  });

Views.CampaignApply = Views.Base.extend({
  el: '.js-campaign-apply-btn',
  events: {
    'click' : 'apply',
  },
  apply: function(event) {
    var $btn, post_data;
    $btn = $(event.currentTarget);

    if (! App.isEnabled($btn)) {
      return;
    }

    // 応募済みか確認する
    if (this.isUniqloCampaignApplied()) {
      alert('すでに応募しています');
      return;
    }

    // ゲストユーザーはポップアップを表示する
    if (! App.me.is_login) {
      location.href = 'mamariq://require_register?trigger=CampaignApply';
      return;
    }

    post_data = {
      "data[token]"       : App.me.token,
      "data[campaign_id]" : '011', // 第11回ポイントキャンペーン
    };

    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/campaign/apply.json',
      data: post_data
    }).done(function(json) {
      // ポップアップを表示させる
      var $popup, is_profile_completed;
      is_profile_completed = App.me.User.address !== '';
      if (is_profile_completed) {
        $popup = $('.js-uniqlo-popup-applied');
      } else {
        $popup = $('.js-uniqlo-popup-settings');
      }
      $popup.css('display', 'inline-block');
      $('.js-uniqlo-popup-close-btn', $popup).click(function(e) {
        $popup.hide();
      });

      // localStorageに応募を記録
      if (! _.isEmpty(localStorage)) {
        localStorage.setItem('is_uniqlo_campaign_applied', 'applied');
      }

      // Mixpanelでトラック
      mixpanel.track('CampaignApply', {'IsProfileCompleted': is_profile_completed});
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
      }
      App.networkErrorAlert();
    }).always(function() {
      App.setEnabled($btn, true);
    });
  },
  isUniqloCampaignApplied: function() {
    // localStorageが利用不可なら応募していないことにする
    if (_.isEmpty(localStorage)) {
      return false;
    }

    // localStorageにフラグが保存されているか確認する
    var is_applied = localStorage.getItem('is_uniqlo_campaign_applied');
    is_applied     = !_.isEmpty(is_applied);
    return is_applied;
  },
});

Views.SeminarCampaignApply = Views.Base.extend({
  el: '.js-seminar-campaign-form',
  events: {
    'click .js-seminar-campaign-form__submit-btn'                           : 'submit',
    'click .js-seminar-campaign-form__append-child'                         : 'appendChild',
    'change .js-seminar-campaign-form__is-pregnancy'                        : 'toggleDeliveryDateVisibility',
    'click .js-seminar-campaign-form__subscribed-insurance__subscribed'     : 'uncheckOppositeOption',
    'click .js-seminar-campaign-form__subscribed-insurance__not-subscribed' : 'uncheckOppositeOption',
  },
  submit: function(event) {
    var _this, $btn, $children, $checked_subscribed_insurance, birthday, child_data, field_validation_list, is_valid, post_data, is_pregnancy, subscribed_insurance, zip_code;
    _this    = this;
    $btn     = $(event.currentTarget);
    is_valid = true;

    if (! App.isEnabled($btn)) {
      return;
    }

    // 入力フィールドが入力されているか確認
    field_validation_list = {
      '.js-seminar-campaign-form__last-name'   : '「姓」を入力して下さい',
      '.js-seminar-campaign-form__first-name'  : '「名」を入力して下さい',
      '.js-seminar-campaign-form__zip-code-1'  : '郵便番号を入力して下さい',
      '.js-seminar-campaign-form__zip-code-2'  : '郵便番号を入力して下さい',
      '.js-seminar-campaign-form__address'     : '市区町村以降の住所を入力して下さい',
      '.js-seminar-campaign-form__phone-number': '電話番号を入力して下さい',
      '.js-seminar-campaign-form__email'       : 'メールアドレスを入力して下さい',
      '.js-seminar-campaign-form__companion'   : '一緒にお越しになるご家族を入力して下さい',
      '.js-seminar-campaign-form__question'    : '教育費や貯金について相談したいことを入力して下さい',
    };
    $.each(_.keys(field_validation_list), function(i, key) {
      var $field = _this.$(key);
      if ($field.val().length === 0) {
        alert(field_validation_list[key]);
        is_valid = false;
        return false;
      }
    });
    if (! is_valid) {
      return;
    }

    // 都道府県の選択をチェック
    if ($('.js-seminar-campaign-form__prefecture-id').val() === null) {
      alert('都道府県を選択して下さい');
      return false;
    }

    // 郵便番号の桁数のチェック
    zip_code = this.$('.js-seminar-campaign-form__zip-code-1').val() + this.$('.js-seminar-campaign-form__zip-code-2').val();
    if (zip_code.length !== 7) {
      alert('郵便番号の形式が正しくありません。正しい郵便番号を入力して下さい');
      return;
    }

    // 妊娠状態が選択されていない場合は、妊娠していないとする
    is_pregnancy = this.$('input[name="data[User][is_pregnancy]"]:checked').val();
    if (typeof is_pregnancy === 'undefined') {
      is_pregnancy = '0';
    }

    // 入力されている子供の情報を取得
    child_data = [];
    $children  = this.$('.js-seminar-campaign-form__child-data');
    $children.each(function(i, child) {
      var $child, birthday, data, is_born, sex;
      $child = $(child);

      sex = $('.js-seminar-campaign-form__child-sex:checked', $child).val();
      // 性別が選択されていない場合、入力されていないデータとする
      if (typeof sex === 'undefined') {
        return true;
      }

      is_born = $('input[name="data[Child][is_born]"]', $child).val();
      // 妊娠中ではないのに予定日のデータが入っている場合はスキップする
      if (is_pregnancy === '0' && is_born === '0') {
        return true;
      }

      birthday = _this.joinDateToPostValue(
        $('select[name="data[Child][year]"]', $child).val(),
        $('select[name="data[Child][month]"]', $child).val(),
        $('select[name="data[Child][day]"]', $child).val()
      );

      data = {
        'id'      : $('input[name="data[Child][id]"]', $child).val(),
        'birthday': birthday,
        'sex'     : sex,
        'is_born' : is_born,
      };
      child_data.push(data);
    });

    // 加入中の保険を取得
    $checked_subscribed_insurance = this.$('.js-seminar-campaign-form__subscribed-insurance input:checked');
    if (! $checked_subscribed_insurance.length) {
      alert('ご家族が加入中の保険を選択して下さい');
      return;
    }
    subscribed_insurance = '';
    $checked_subscribed_insurance.each(function(i, checkbox) {
      var $checkbox = $(checkbox);
      subscribed_insurance += '【' + $checkbox.val() + '】'
    });

    birthday = this.joinDateToPostValue(
      this.$('select[name="data[User][year]"]').val(),
      this.$('select[name="data[User][month]"]').val(),
      this.$('select[name="data[User][day]"]').val()
    );

    // 空配列は送れないので子供の情報がない場合はChildのデータを空文字にする
    child_data = child_data.length ? child_data : '';

    post_data = {
      data: {
        token: App.me.token,
        User: {
          first_name   : this.$('.js-seminar-campaign-form__first-name').val(),
          last_name    : this.$('.js-seminar-campaign-form__last-name').val(),
          prefecture_id: this.$('.js-seminar-campaign-form__prefecture-id').val(),
          address      : this.$('.js-seminar-campaign-form__address').val(),
          phone_number : this.$('.js-seminar-campaign-form__phone-number').val().replace(/[\-]/g, ''),
          email        : this.$('.js-seminar-campaign-form__email').val(),
          zip_code     : zip_code,
          is_pregnancy : is_pregnancy,
          birthday     : birthday,
        },
        Child   : child_data,
        Campaign: {
          companion           : this.$('.js-seminar-campaign-form__companion').val(),
          question            : this.$('.js-seminar-campaign-form__question').val(),
          subscribed_insurance: subscribed_insurance,
        }
      }
    };

    App.changeText($btn, "通信中...");
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      },
      url: '/api/campaign/apply.json',
      data: post_data
    }).done(function(json) {
      alert('キャンペーンへの応募を受付ました。\nご応募ありがとうございます！');
      mixpanel.track('CampaignApply', {'CampaignId' : '007'});
      App.changeText($btn, 'ご応募ありがとうございました');
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);

      App.restoreText($btn);
      App.setEnabled($btn, true);

      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message);
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
  appendChild: function(event) {
    var $btn, content, html, num;
    $btn    = $(event.currentTarget);
    num     = this.$('.js-seminar-campaign-form__borned-child > .js-seminar-campaign-form__child-data').length + 1;
    content = {'Num' : num};
    html    = App.Templates.children_info(content);
    $btn.parent().before(html);
  },
  toggleDeliveryDateVisibility: function(event) {
    var $delivery_date_info, $is_pregnancy_radio;
    $is_pregnancy_radio = $(event.currentTarget);
    $delivery_date_info = this.$('.js-seminar-campaign-form__delivery-date');
    // 妊娠してない場合は非表示にする
    if ($is_pregnancy_radio.val() === '0') {
      $delivery_date_info.hide();
    } else {
      $delivery_date_info.show();
    }
  },
  uncheckOppositeOption: function(event) {
    var uncheck_class;
    // 「なし」とそれ以外の選択肢が同時に押されないようにする
    if ($(event.currentTarget).hasClass('js-seminar-campaign-form__subscribed-insurance__subscribed')) {
      uncheck_class = '.js-seminar-campaign-form__subscribed-insurance__not-subscribed';
    } else {
      uncheck_class = '.js-seminar-campaign-form__subscribed-insurance__subscribed';
    }
    $(uncheck_class).prop('checked', false);
  },
  joinDateToPostValue: function(year, month, day) {
    return [
      year,
      ('00' + month).slice(-2),
      ('00' + day).slice(-2)
    ].join('-');
  },
});

Views.NotificationMarkAsRead = Views.Base.extend({
  el: '.notification__list__link__info__as-read-btn',
  events: {
    'click': 'markAsRead',
  },
  markAsRead: function(event) {
    var $list_item, req_data;

    // ユーザーによる操作キャンセル
    if (! confirm('このお知らせを既読にします。よろしいですか？')) {
      return;
    }

    $list_item = $(event.currentTarget);
    req_data = {
      data: {
        Notification: {
          id             : $list_item.data('notificationId'),
          target_user_id : App.me.User.id,
          type           : $list_item.data('type'),
          etc_id         : $list_item.data('etcId'),
          is_read        : true
        },
        token: App.me.token
      }
    };

    $.ajax({
      url      : '/api/notification/edit',
      dataType : 'json',
      type     : 'post',
      data     : req_data,
      headers  : {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      }
    }).done(function(res) {
      // 親のli要素の「未読」表示を解除
      $list_item.parent('li').removeClass('unread');
      // 押されたボタンを除去
      $list_item.remove();
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
});

Views.ArticleContent = Views.Base.extend({
  events: {
    'click': 'readArticle'
  },
  readArticle: function() {
    // Newラベルが表示されていたら削除して既読リストへ追加する
    var $newLabel = this.$('.js-article-new-label');
    var articleId = this.$el.data('articleId').toString();
    if ($newLabel.length) {
      $newLabel.remove();
      this.pushReadArticleList(articleId);
    }

    // Mixpanelへ表示イベントを送る
    mixpanel.track('ArticleShow', {
      'ArticleId': articleId,
      'DisplayIndex': $('.js-article-content').index(this.$el)
    });
  },
  pushReadArticleList: function(article_id) {
    var read_article_list;
    read_article_list = this.getReadArticleList();
    read_article_list.push(article_id);
    read_article_list = _.uniq(read_article_list);
    localStorage.setItem('read_article_list', JSON.stringify(read_article_list));
  },
  getReadArticleList: function() {
    var read_article_list;

    // まだLocalStorageにデータが無ければ空配列を保存する
    if (! localStorage.getItem('read_article_list')) {
      localStorage.setItem('read_article_list', '[]');
    }

    read_article_list = JSON.parse(localStorage.getItem('read_article_list'));
    return read_article_list;
  },
});

// @todo 将来的にはarticle系のutilとかにするべき
// 該当の記事が「最新(トップ掲載24h以内)」の定義内であるか判定
var isRecentArticle = function(now, articleCatchyPriority) {
  // `-`だとwebkitでinvalidになってしまいパースできない
  var articleDate = new Date(articleCatchyPriority.replace(/-/g, '/'));
  // 年と月が一緒か
  if (now.getFullYear() !== articleDate.getFullYear() || now.getMonth() !== articleDate.getMonth()) {
    return false;
  }
  // 現在時間との差分を取る
  var diffDate = new Date(now - articleDate);
  // 1970/1/1基準での差分なので1970/1/1なら24h以内
  return diffDate.getDate() <= 1;
};

Views.ArticleTop = Views.ArticleContent.extend({
  el: '.js-article-top',
  initialize: function() {
    // 未読かどうか
    var articleId = this.$el.data('articleId').toString();
    var isUnread = !_.contains(this.getReadArticleList(), articleId);
    if (isUnread) {
      // 未読ならタブに新着マーク表示
      location.href = 'mamariq://unread_new_article?article_id=' + articleId;
    }

    // 新着記事かどうか
    var $newLabel = this.$('.js-article-new-label');
    var isRecent = isRecentArticle(new Date(), this.$el.data('articleCatchyPriority'));
    if (isUnread && isRecent) {
      // 24h以内にトップ掲載かつ未読の記事であれば記事に新着ラベル表示
      $newLabel.show();
    } else {
      $newLabel.remove();
    }
  }
});

// 記事リスト
Views.ArticleListContent = Views.ArticleContent.extend({
  className: 'article-list-content js-article-content',
  tagName: 'li',
  template: App.Templates.article_list_content,
  props: {
    utmMedium: null,
    showFavoriteCount: null
  },
  initialize: function(options) {
    // default
    this.props.utmMedium = 'news';
    this.props.showFavoriteCount = false;

    if (options != null) {
      // utm_mediumが指定されていれば設定
      if (_.has(options, 'utmMedium')) {
        this.props.utmMedium = options.utmMedium;
      }
      // お気に入り数を表示するかどうかのフラグ設定
      if (_.has(options, 'showFavoriteCount')) {
        this.props.showFavoriteCount = options.showFavoriteCount;
      }
    }
  },
  render: function(content) {
    content.utmMedium = this.props.utmMedium;
    content.showFavoriteCount = this.props.showFavoriteCount;
    var html = this.template(content);
    this.$el.html(html);
    this.$el.data('articleId', content.Article.id);
    return this;
  }
});

Views.ArticleLoad = Views.Base.extend({
  el: '.js-article-list',
  limit: 40,
  offset: 'now',
  page: 0,
  is_getting_article: false,
  is_finish: false,
  append_count: 0,
  $feature_headline: null,
  initialize: function() {
    this.$feature_headline = $('.js-feature-headline');

    // 初期記事を追加する
    var _this = this;
    var now = new Date();
    var readArticles = this.getReadArticleList();
    _.each(App.vars.articles, function(article) {
      // 24h以内の記事かつ未読でないとnewマークを表示しない
      var isRecent = isRecentArticle(now, article.Article.catchy_priority);

      // 広告枠で予約された記事は未読なら常にnewマークを表示する
      if (article.Article.is_ad_article) {
        isRecent = true;
      }

      article.Article.is_read = !isRecent || _.contains(readArticles, article.Article.id.toString());
      _this.appendArticle(article);
    });

    // 最後の記事のcatchy_priorityをoffsetとして保持
    this.offset = _.last(App.vars.articles).Article.catchy_priority;

    // 下までスクロールしたら古い記事を読み込む
    $(window).on('scroll touchmove', function() {
      var scrollHeight   = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();
      // 残スクロールエリアが1200pxを下回った場合
      if (scrollHeight - scrollPosition < 1200) {
        _this.getArticle();
      }
    });

    // ローディングを常に表示する
    $('.js-bottom-load-indicator').show();
  },
  appendArticle: function(article) {
    var html = new Views.ArticleListContent({ showFavoriteCount: true }).render(article);
    if (this.append_count < 9) {
      // 9本目までは特集の上に追加
      this.$feature_headline.before(html.$el);
    } else {
      // 9本目以降は特集の下に追加
      this.$el.append(html.$el);
    }
    this.append_count++;
  },
  getReadArticleList: function() {
    var read_article_list;

    // まだLocalStorageにデータが無ければ空配列を保存する
    if (! localStorage.getItem('read_article_list')) {
      localStorage.setItem('read_article_list', '[]');
    }

    read_article_list = JSON.parse(localStorage.getItem('read_article_list'));
    return read_article_list;
  },
  getArticle: function() {
    // Article取得中 or 取得できるArticleをすべて取得したかどうか
    if (this.is_getting_article || this.is_finish) {
      return;
    }
    this.is_getting_article = true;

    // ログインしている場合はUUIDをheaderに付ける
    var headers = {};
    if (App.me.is_login) {
      headers['X-MAMARIQ-UUID'] = App.me.User.uuid;
      headers['X-MAMARIQ-APP-VERSION'] = App.me.app_version;
    }

    var _this = this;
    $.ajax({
      type: 'GET',
      headers: headers,
      url: '/api/article/index.json',
      beforeSend: function() {},
      data: {
        offset: this.offset,
        limit: this.limit
      }
    }).done(function(json) {
      // 最後まで読み終わったときの処理
      if (json.response.length === 0) {
        _this.is_finish = true;
        // ローディングを消す
        return $('.js-bottom-load-indicator').hide();
      }

      // 記事を追加していく
      var now = new Date();
      var readArticles = _this.getReadArticleList();
      _.each(json.response, function(article) {
        // 24h以内の記事かつ未読でないとnewマークを表示しない
        var isRecent = isRecentArticle(now, article.Article.catchy_priority);
        article.Article.is_read = !isRecent || _.contains(readArticles, article.Article.id);
        _this.appendArticle(article);
      });

      // 最後の記事のcatchy_priorityをoffsetとして保持
      _this.offset = _.last(json.response).Article.catchy_priority;

      // 2ページ目以降はPVを計測する
      _this.page++;
      if (_this.page >= 2) {
        ga('mamari_common.set', {page: location.pathname + '?page=' + _this.page});
        ga('mamari_common.send', 'pageview');
        ga('mamari_q.set', {page: location.pathname + '?page=' + _this.page});
        ga('mamari_q.send', 'pageview');
      }
    }).fail(function(jqXHR) {
      // ローディングを消す
      $('.js-bottom-load-indicator').hide();

      var data = App.parseError(jqXHR);
      if (!data) {
        return;
      }
      if (_.has(data.error, 'message')) {
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      _this.is_getting_article = false;
    });
  }
});

Views.FavoriteArticleLoad = Views.Base.extend({
  el: '.js-article-list',
  initialize: function() {
    var $article_list, html;
    $article_list = $('.js-article-list');
    _.each(App.vars.articles, function(article) {
      article.Article.is_read = true;
      html = new Views.ArticleListContent({ utmMedium: 'favorite' }).render(article);
      $article_list.append(html.$el);
    });
  }
});

Views.ArticleSearchForm = Views.Base.extend({
  el: '.js-article-search-form',
  events: {
    'submit' : 'overrideSubmitAction'
  },
  overrideSubmitAction: function(event) {
    var $input, href, query;
    $input = this.$el.find('.js-article-search-form-input');
    query  = $input.val();
    href   = 'http://mamari.jp/search?q='
      + encodeURIComponent(query)
      + '&utm_source=mamariq_app&utm_medium=search';

    // 検索クエリが無い場合は検索しない
    if (query.length === 0) {
      App.Views.simpleMessageAlert.show('検索したいワードを入力してください');
      return false;
    }

    // iOSは仮想DOMでクリックイベントを起こす
    if (App.me.is_ios) {
      $("<a></a>", {
        href: href,
      }).get(0).click();
    } else {
      location.href = href;
    }

    // イベントトラック
    mixpanel.track('ArticleSearch', {'Query' : query});
    return false;
  }
});

Views.TagSearch = Views.Base.extend({
  el: '.js-tag-search-box',
  events: {
    'click .js-tag-search-submit': 'searchTag',
  },
  searchTag: function(event) {
    var query, href, is_available_tag_search, is_available_local_storage, request_message;

    // Review済みかチェックする
    // LocalStorageが使えない場合は常に許可
    is_available_local_storage = this.isAvailableLocalStorage();
    is_available_tag_search    = is_available_local_storage ? (localStorage.getItem('is_available_tag_search') === 'true') : true;
    if (! is_available_tag_search) {
      // Alertの表示をトラック
      mixpanel.track('TagSearchAlertShow');

      request_message = '【ママリを応援して「タグ検索機能」を使おう！】\nママリを応援する内容のレビューをアプリストアで書くと、タグが検索できるようになります♡レビューを書きますか？';
      if (window.confirm(request_message)) {
        if (App.me.is_ios) {
          // AppStore
          location.href = 'itms-apps://itunes.apple.com/app/id867414015';
        } else {
          // GooglePlay
          location.href = 'https://play.google.com/store/apps/details?id=com.connehito.mamariq';
        }
        // レビューをしたことを保存
        if (is_available_local_storage) {
          localStorage.setItem('is_available_tag_search', 'true');
        }

        // レビューの開始をトラック
        mixpanel.track('TagSearchAlertReview');
      } else {
        // レビューの拒否をトラック
        mixpanel.track('TagSearchAlertDeny');
      }
      return;
    }

    query = this.$('.js-tag-search-text').val();
    if (query.trim().length === 0) {
      App.Views.simpleMessageAlert.show('気になるタグを入力しましょう！');
      return;
    }

    href = '/tag/search?q=' + query;

    // iOSは仮想DOMでクリックイベントを起こす
    if (App.me.is_ios) {
      $("<a></a>", {
        href: href,
      }).get(0).click();
    } else {
      location.href = href;
    }
    // 検索イベントをトラック
    mixpanel.track('SearchTag', {'Query': query});
  },
  isAvailableLocalStorage: function() {
    var exclude_question_list;

    // そもそもLocalStorageがない場合は不可
    if (_.isEmpty(localStorage)) {
      return false;
    }

    // 無限スクロールの値があればLocalStorageがちゃんと働いているということなので
    // それをLocalStorageが使えるかどうかのフラグにする
    exclude_question_list = localStorage.getItem('exclude_question_list');
    return !_.isEmpty(exclude_question_list);
  }
});

Views.AnnouncementLoad = Views.Base.extend({
  el: '.js-announcement-list',
  initialize: function() {
    var _this = this;
    var readAnnouncements = [];
    if (!_.isEmpty(localStorage)) {
      readAnnouncements = this.getReadAnnouncementList();
    }
    _.each(App.vars.announcements, function(announcement) {
      if (announcement.Announcement.is_link &&
          announcement.Announcement.body.indexOf('http') === 0 &&
          !App.vars.is_able_to_open_outbound_link) {
          return true;
      }
      if (_.isEmpty(localStorage)) {
        // LocalStorageが利用不可なら全て既読扱い
        announcement.Announcement.is_read = true;
      } else {
        announcement.Announcement.is_read = _.contains(readAnnouncements, announcement.Announcement.id.toString());
      }
      var html = new Views.AnnouncementListContent().render(announcement);
      _this.$el.append(html.$el);
    });
  },
  getReadAnnouncementList: function() {
    // まだLocalStrageにデータが無ければ空配列を保存する
    if (! localStorage.getItem('read_announcement_list')) {
      localStorage.setItem('read_announcement_list', '[]');
    }

    var read_announcement_list = JSON.parse(localStorage.getItem('read_announcement_list'));
    return read_announcement_list;
  }
});

Views.AnnouncementListContent = Views.Base.extend({
  className: 'announcement__list',
  tagName: 'li',
  template: App.Templates.announcement_list_content,
  events: {
    click: 'readAnnouncement'
  },
  readAnnouncement: function() {
    // 未読だったら既読表示にしてリストへ追加する
    var announcementId = this.$el.data('announcementId').toString();
    if (this.$el.hasClass('unread')) {
      this.$el.removeClass('unread');
      this.pushReadAnnouncementList(announcementId);
    }

    // Mixpanelへ表示イベントを送る
    mixpanel.track('AnnouncementShow', {
      'AnnouncementId': announcementId,
      'DisplayPage': location.pathname.substr(1),
      'DisplayIndex': $('.annoucnement__list').index(this.$el)
    });
  },
  pushReadAnnouncementList: function(announcement_id) {
    // localStorageが利用不可なら何もしない
    if (_.isEmpty(localStorage)) {
      return false;
    }
    var read_announcement_list = this.getReadAnnouncementList();
    read_announcement_list.push(announcement_id);
    read_announcement_list = _.uniq(read_announcement_list);
    localStorage.setItem('read_announcement_list', JSON.stringify(read_announcement_list));
  },
  getReadAnnouncementList: function() {
    // まだLocalStrageにデータが無ければ空配列を保存する
    if (! localStorage.getItem('read_announcement_list')) {
      localStorage.setItem('read_announcement_list', '[]');
    }
    var read_announcement_list = JSON.parse(localStorage.getItem('read_announcement_list'));
    return read_announcement_list;
  },
  render: function(content) {
    var html = this.template(content);
    this.$el.html(html);
    if (! content.Announcement.is_read) {
      this.$el.addClass('unread');
    }
    this.$el.data('announcementId', content.Announcement.id);
    return this;
  }
});

Views.BirthdaySetConfirm = Views.Base.extend({
  className: 'p-birthday-set-confirm',
  tagName: 'div',
  template: App.Templates.birthday_set_confirm,
  events: {
    'click .js-birthday-set-confirm-submit': 'setBirthday',
    'click .js-birthday-set-confirm-close': 'close'
  },
  props: {
    childId: null
  },
  initialize: function(options) {
    if (options != null && _.has(options, 'childId')) {
      this.props.childId = options.childId;
    }
  },
  show: function() {
    $.fancybox(this.$el, {
      closeBtn : false,
      minWidth : '100%',
      minHeight: '120px'
    });
  },
  close: function() {
    // confirmを閉じる
    $.fancybox.close()
  },
  setBirthday: function() {
    // confirmを閉じる
    $.fancybox.close()

    // 誕生日入力を表示する
    var popup = new App.Views.BirthdaySetPopup({ childId: this.props.childId }).render();
    popup.show();
  },
  render: function() {
    var html = this.template();
    this.$el.html(html);
    return this;
  }
});

Views.BirthdaySetPopup = Views.Base.extend({
  className: 'c-popup-wrapper',
  tagName: 'div',
  template: App.Templates.birthday_set_popup,
  events: {
    'click .js-birthday-popup-set-submit': 'submit',
    'click .js-birthday-popup-set-close' : 'close'
  },
  props: {
    childId: null
  },
  initialize: function(options) {
    if (options != null && _.has(options, 'childId')) {
      this.props.childId = options.childId;
    }
  },
  submit: function(event) {
    // 通信中はボタンが無効
    var $btn = $(event.currentTarget);
    if (! App.isEnabled($btn)) {
      return;
    }

    // 性別が選択されているかチェック
    var sex = this.$('input[name="data[Child][sex]"]:checked').val();
    if (typeof sex === 'undefined') {
      alert('性別を選択してください');
      return;
    }

    var birthday = this.$('input[name="data[Child][birthday]"]').val();
    var birthdayTs = Math.floor(Date.parse(birthday) / 1000) - 9 * 60 * 60; // 日本時間の0時に変換
    var nowTs = Math.floor(new Date().getTime() / 1000);
    if (birthdayTs > nowTs) {
      alert('本日以前の日付を入力してください');
      return;
    }

    var postData = {
      data: {
        token: App.me.token,
        Child: {
          id: this.props.childId,
          birthday: birthday,
          sex: sex,
          is_born: '1' // PHPでstringに変換されてる場合があるので`true`の意味で'1'をPOSTする
        }
      }
    };

    App.setEnabled($btn, false);
    $.ajax({
      url     : '/api/child/edit',
      dataType: 'json',
      type    : 'post',
      data    : postData,
      headers : { 'X-MAMARIQ-UUID': App.me.User.uuid }
    }).done(function() {
      // Popupを閉じる
      $.fancybox.close();

      // イベントトラック
      mixpanel.track('BirthdayPopupSubmit');

      // ページをリロード
      location.href = 'mamariq://reload';
    }).fail(function(jqXHR) {
      // ボタンを再有効化
      App.setEnabled($btn, true);

      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message);
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
  show: function() {
    $.fancybox(this.$el, {
      closeBtn : false,
      minWidth : '100%',
      minHeight: '120px'
    });
  },
  close: function() {
    $.fancybox.close();
  },
  render: function() {
    var date = new Date();
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    var content = {
      date: year + '-' + month + '-' + day
    };
    var html = this.template(content);
    this.$el.html(html);
    return this;
  }
});

Views.BirthdayPopupBanner = Views.Base.extend({
  el: '.js-birthday-popup-banner',
  initialize: function() {
    var birthday_ts, children, now_ts, redisplay_threshold_ts, youngest_child;
    children = App.me.Child;

    // ログインしていないユーザーには表示しない
    if (! App.me.is_login) {
      return;
    }

    // 子供が居なければ表示しない
    if (children.length === 0) {
      return;
    }

    // 一番若いChildを取得
    youngest_child = _.first(children);

    // 予定日がまだ来ていなければ表示しない
    birthday_ts = Math.floor(Date.parse(youngest_child.birthday) / 1000) - 9 * 60 * 60; // 日本時間の0時に変換
    now_ts      = Math.floor(new Date().getTime() / 1000);
    if (birthday_ts > now_ts) {
      return;
    }

    // すでに出生済みと設定されているなら表示しない
    if (youngest_child.is_born) {
      return;
    }

    // 再表示期間を超えている場合は表示する
    // 最初は0で必ず表示する
    redisplay_threshold_ts = localStorage.getItem('birthday_popup_banner_redisplay_threshold_ts') || 0;
    if (now_ts > redisplay_threshold_ts) {
      this.$el.data('childId', youngest_child.id);
      this.$el.show();
    };
  },
  events: {
    'click .js-birthday-popup-banner-set':    'showSetPopup',
    'click .js-birthday-popup-banner-remind': 'showRemindPopup',
  },
  showSetPopup: function(event) {
    var $popup = $('.js-birthday-popup-set');
    $.fancybox($popup, {
      closeBtn: false,
      //minWidth  : '100%', 適宜設定してください
      //minHeight : '120px',
    });
  },
  showRemindPopup: function(event) {
    var $popup = $('.js-birthday-popup-remind');
    $.fancybox($popup, {
      closeBtn  : false,
      //minWidth  : '100%', 適宜設定してください
      //minHeight : '120px',
    });
  },
});

Views.BirthdayPopupSet = Views.Base.extend({
  el: '.js-birthday-popup-set',
  events: {
    'click .js-birthday-popup-set-submit': 'submitBirthday',
    'click .js-birthday-popup-set-close' : 'closePopup',
  },
  submitBirthday: function(event) {
    var birthday, birthday_ts, now_ts, post_data, sex;

    // 性別が選択されているかチェック
    sex = this.$('input[name="data[Child][sex]"]:checked').val();
    if (typeof sex === 'undefined') {
      alert('性別を選択してください');
      return;
    }

    birthday    = this.$('input[name="data[Child][birthday]"]').val();
    birthday_ts = Math.floor(Date.parse(birthday) / 1000) - 9 * 60 * 60; // 日本時間の0時に変換
    now_ts      = Math.floor(new Date().getTime() / 1000);
    if (birthday_ts > now_ts) {
      alert('有効な日付を入力してください');
      return;
    }

    post_data = {
      'data[token]'          : App.me.token,
      'data[Child][id]'      : $('.js-birthday-popup-banner').data('childId'),
      'data[Child][birthday]': birthday,
      'data[Child][sex]'     : sex,
      'data[Child][is_born]' : '1', // PHPでstringに変換されてる場合があるので`true`の意味で'1'をPOSTする
    };

    $.ajax({
      url      : '/api/child/edit',
      dataType : 'json',
      type     : 'post',
      data     : post_data,
      headers  : {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      }
    }).done(function(res) {
      // Popupを閉じてバナーも削除する
      $.fancybox.close();
      $('.js-birthday-popup-banner').remove();

      // イベントトラック
      mixpanel.track('BirthdayPopupSubmit');
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
  closePopup: function(event) {
    $.fancybox.close();
  },
});

Views.BirthdayPopupRemind = Views.Base.extend({
  el: '.js-birthday-popup-remind',
  initialize: function() {
    // 再通知を以前に押してない場合は「今後表示しない」の選択肢を表示しない
    var redisplay_threshold_ts = localStorage.getItem('birthday_popup_banner_redisplay_threshold_ts') || 0;
    if (redisplay_threshold_ts === 0) {
      $('.js-birthday-popup-remind-deny').remove();
    }
  },
  events: {
    'click .js-birthday-popup-remind-later': 'remindLater',
    'click .js-birthday-popup-remind-deny' : 'remindDeny',
    'click .js-birthday-popup-remind-close': 'closePopup',
  },
  remindLater: function(event) {
    var now_ts, threshold_ts;

    // 1週間後に再度表示する
    now_ts       = Math.floor(new Date().getTime() / 1000);
    threshold_ts = now_ts + (7 * 24 * 60 * 60);
    localStorage.setItem('birthday_popup_banner_redisplay_threshold_ts', threshold_ts);
    // Popupを閉じてバナーも削除する
    $.fancybox.close();
    $('.js-birthday-popup-banner').remove();

    // イベントトラック
    mixpanel.track('BirthdayPopupRemind');
  },
  remindDeny: function(event) {
    var post_data;

    if (! confirm('今後表示させないためにお子さんのデータを削除しますがよろしいですか？')) {
      return;
    }

    post_data = {
      'data[token]'    : App.me.token,
      'data[Child][id]': $('.js-birthday-popup-banner').data('childId'),
    };

    $.ajax({
      url      : '/api/child/remove',
      dataType : 'json',
      type     : 'post',
      data     : post_data,
      headers  : {
        'X-MAMARIQ-UUID': App.me.User.uuid,
      }
    }).done(function(res) {
      // Popupを閉じてバナーも削除する
      $.fancybox.close();
      $('.js-birthday-popup-banner').remove();

      // イベントトラック
      mixpanel.track('BirthdayPopupDeny');
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message); //@todo エラーコードによって分岐
        }
        return;
      }
      App.networkErrorAlert();
    });
  },
  closePopup: function(event) {
    $.fancybox.close();
  },
});

// キャンペーン用住所入れてくださいポップアップ
Views.CampaignAddressInputPopup = Views.Base.extend({
  props: {
    storageKeyPrefix: 'is_campaign_address_input_shown_',
    storageKey: null
  },
  initialize: function() {
    this.props.storageKey = this.props.storageKeyPrefix + this.attributes.campaignId;
  },
  show: function() {
    // 既に1度表示済なら表示しない
    if (this.isShown()) {
      return;
    }

    // ポップアップを表示
    var $popup = $('.js-campaign-address-input-popup');
    $popup.css('display', 'inline-block');
    $('.js-campaign-address-input-popup-close-btn', $popup).click(function() {
      $popup.remove();
    });

    // localStorageに表示を記録
    if (!_.isEmpty(localStorage)) {
      localStorage.setItem(
        this.props.storageKey,
        'shown'
      );
    }

    // Mixpanelでトラック
    mixpanel.track('CampaignApply', { CampaignId: this.attributes.campaignId });
  },
  isShown: function() {
    // localStorageが利用不可なら表示してないことにする
    if (_.isEmpty(localStorage)) {
      return false;
    }

    // localStorageにフラグが保存されているか確認する
    var isShown = localStorage.getItem(this.props.storageKey);
    return !_.isEmpty(isShown);
  }
});

Views.PointCampaignApply = Views.Base.extend({
  el: '.js-point-campaign-apply-button',
  events: {
    'click': 'applyCampaign'
  },
  applyCampaign: function() {
    var $btn = this.$el;

    // inactiveのクラスが付いている場合は処理しない
    if ($btn.hasClass('p-point-cp__content__btn--inactive')) {
      return;
    }

    // 通信中は処理しない
    if (! App.isEnabled($btn)) {
      return;
    }

    App.setEnabled($btn, false);
    $.ajax({
      url      : '/api/campaign/apply',
      dataType : 'json',
      type     : 'post',
      data     : {
        data: {
          token: App.me.token,
          campaign_id: location.pathname.match(/[0-9]+$/)[0]
        }
      },
      headers: { 'X-MAMARIQ-UUID': App.me.User.uuid }
    }).done(function() {
      var $currentPoint = $('.js-point-campaign-current-point');
      var $applyCount = $('.js-point-campaign-apply-count');
      var $btnTitle = $('.js-point-campaign-apply-button-title');
      var $btnDescription = $('.js-point-campaign-apply-button-description');

      // 応募回数を増やす
      var applyCount = $applyCount.first().text();
      applyCount = parseInt(applyCount, 10) + 1;
      $applyCount.text(applyCount);

      // ポイントを減らす
      var currentPoint = $currentPoint.first().text().replace(/,/g, ''); // commaを除く
      currentPoint = parseInt(currentPoint, 10);
      currentPoint = currentPoint - 100;
      currentPoint = String(currentPoint).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); // commaを入れる
      $currentPoint.text(currentPoint);

      // ボタンのclassを変更
      $btn.addClass('p-point-cp__content__btn--inactive');
      $btn.removeClass('p-point-cp__content__btn--active');

      // ボタンの文言の変更
      $btnTitle.text('本日の応募は完了しました');
      $btnDescription.text('ありがとうございます！毎日応募で当選確率アップ♪');

      // ポップアップを表示
      // 住所がまだ未入力の場合は、入力を促すポップアップを表示する
      var popupClass = _.isEmpty(App.me.User.address) ?
        '.js-point-campaign-popup-settings' : '.js-point-campaign-popup-complete';
      var $popup = $(popupClass);
      $popup.css('display', 'inline-block');
      $('.js-point-campaign-popup-close', $popup).click(function() {
        $popup.remove();
      });
    }).fail(function(jqXHR) {
      var data = App.parseError(jqXHR);
      if (! data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message);
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function() {
      App.setEnabled($btn, true);
    });
  }
});

Views.HospitalReviewAddForm = Views.Base.extend({
  el: ".js-hospital-review-form",
  events: {
    "submit" : "submitHospitalReview"
  },
  submitHospitalReview: function(event) {
    event.preventDefault();
    var $btn = this.$('.js-hospital-review-form-submit');
    if (!App.isEnabled($btn)) {
      return;
    }

    var postData = {
      "data[token]": App.me.token
    };
    _.each(this.$el.serializeArray(), function(el) {
      postData[el.name] = el.value;
    });
    App.setEnabled($btn, false);
    $.ajax({
      type: 'POST',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid
      },
      url: '/api/hospital/review/add.json',
      data: postData
    }).done(function(json) {
      mixpanel.track("HospitalReviewAdd");
      var moveTo = '/hospital/review/add/complete';
        if (App.me.is_ios) {
          $("<a></a>", {
            href: moveTo
          }).get(0).click();
        } else {
          location.href = moveTo;
        }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      var data = App.parseError(jqXHR);
      if (!data) {
        App.networkErrorAlert();
        return;
      }
      if (_.has(data.error, 'message')) {
        if (data.error.validation) {
          var causeFields = _.keys(data.error.validation.HospitalReview);
          mixpanel.track('HospitalReviewAddAlert', {cause: causeFields});
          App.validateErrorAlert(data.error.validation);
        } else {
          alert(data.error.message);
          if (data.error.code === 2003) {
            // 情報が登録済みの場合はmypageに戻す
            if (App.me.is_ios) {
              $("<a></a>", {
                href: 'mamariq://back_to_top'
              }).get(0).click();
            } else {
              location.href = 'mamariq://back_to_top';
            }
          }
        }
        return;
      }
      App.networkErrorAlert();
    }).always(function(){
      App.setEnabled($btn, true);
    });
  }
});

Views.HospitalReviewAddSearchForm = Views.Base.extend({
  el: '.js-hospital-review-add-search-form',
  events: {
    submit: 'trackSearchHospital'
  },
  trackSearchHospital: function() {
    mixpanel.track('HospitalReviewAddSearch', {
      Prefecture: $('.js-hospital-review-add-district option:selected').text(),
      HospitalName: $('.js-hospital-review-add-hospital-name').val()
    });
  }
});

Views.FpReserve = Views.Base.extend({
  el: '#fpReservation',
  events: {
    'click #manualLink': 'redirectToAu',
  },
  initialize: function () {
    const params = new URLSearchParams(location.search);
    $('input[name="timestamp"]').val(this.getTimestampStr(new Date()));
    $('input[name="customer_id"]').val(params.get('user_id'));
    $('input[name="employee_id"]').val(params.get('fpp_id'));

    this.redirectToAu();
  },
  redirectToAu: function () {
    $('#reservationForm').submit();
  },
  // 日付を yyyymmddhhmmssSSS 形式文字列に変換する
  getTimestampStr: function (date) {
    const padZero = (n, len) => {
      return n.toString().padStart(len, '0');
    }

    const year = date.getFullYear().toString();
    const month = padZero((date.getMonth() + 1), 2);
    const day = padZero(date.getDate(), 2);
    const hour = padZero(date.getHours(), 2);
    const minute = padZero(date.getMinutes(), 2);
    const second = padZero(date.getSeconds(), 2);
    const millisecond = padZero(date.getMilliseconds(), 3);

    return `${year}${month}${day}${hour}${minute}${second}${millisecond}`;
  }
});

// 画面ヘッダーの閉じるボタンのイベント
Views.AppBannerClose = Views.Base.extend({
  el: '.js-app-banner',
  events: {
    'click .js-app-banner__close-button' : 'close'
  },
  close: function() {
    $('.js-app-banner').css('display', 'none');
  },
});

module.exports = Views;



// WEBPACK FOOTER //
// ./webroot/js/view.js